import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export interface AvnetUsaV3CredentialsDTO extends z.infer<typeof AvnetUsaV3CredentialsDTORuntype> {}
export const AvnetUsaV3CredentialsDTORuntype = z.object({
    client_id: z.string(),
    client_secret: z.string(),
    subscription_key: z.string(),
    sold_to_acct_number: z.string().optional(),
});

export interface AvnetUsaV3CredentialsInputDTO extends z.infer<typeof AvnetUsaV3CredentialsInputDTORuntype> {}
export const AvnetUsaV3CredentialsInputDTORuntype = z.object({
    client_id: z.string().optional(),
    client_secret: z.string().optional(),
    subscription_key: z.string().optional(),
    sold_to_acct_number: z.string().nullable(),
});

export interface AvnetUsaV3ResponseBodyDTO extends z.infer<typeof AvnetUsaV3ResponseBodyDTORuntype> {}
export const AvnetUsaV3ResponseBodyDTORuntype = z.object({
    data: AvnetUsaV3CredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
